import VideoPlaybackOptions from "@core/libs/video_playback_options";

export {};

document.addEventListener('started', () => {
    app.voyo.playTrailer('.movie_page .media');
});

document.addEventListener('started-bookmarks', () => {
    const voyokey = app.html.getData('.movie_page', 'voyokey');

    if (app.bookmarks.isBookmarked('GRP_DEFAULT', voyokey)) {
        app.html.addClass('.movie_page', 'myVoyo');
    }

    const bookmark = app.bookmarks.isBookmarked('stayedAt', voyokey);
    if (bookmark) {
        app.html.addClass('.movie_page', 'stayedAt');
        app.html.setStyle('.progressbar .line', 'width', bookmark.percent + '%');
        app.html.addClass('.progressbar', 'progressbar--active');
        app.html.show('.progressbar');
    }
});

function playInPlace(mediaId: number, playbackOptions: VideoPlaybackOptions = {}): void {
    if (!window.app) {
        return;
    }

    if (app.playRestriction.restrictAppPlayback()) {
        return;
    }

    app.voyoVideo.stopVideoPlayers();
    app.html.addClass('body', 'playing_content');

    const bookmark = app.bookmarks.isBookmarked('stayedAt', mediaId);
    if (bookmark && bookmark.percent < 90) {
        playbackOptions.startAt = bookmark.duration;
    }

    app.voyoVideo.initForPlay('.player_box video', mediaId, playbackOptions)
        .then(() => {
            app.html.q('.player')?.focus();
        });
}

function stopWatching(mediaId: string): void {
    if (!window.app) {
        return;
    }

    app.bookmarks.voyoBookmarkRemove('stayedAt', mediaId)
        .then(() => {
            app.html.removeClass('.movie_page', 'stayedAt');
        });
}

function muteUnmuteTrailerVolume(event: Event) {
    if (!window.app) {
        return;
    }

    app.voyoVideo.muteUnmuteTrailerVolume(event);
}

window.addEventListener('beforeunload', () => {
    if (window.app) {
        app.voyoVideo.stopVideoPlayers();
    }
});

window.playInPlace = playInPlace;
window.stopWatching = stopWatching;
window.muteUnmuteTrailerVolume = muteUnmuteTrailerVolume;
